import {Component, Input} from '@angular/core';
import {SafeStyle} from '@angular/platform-browser';

@Component({
  selector: 'das-styleable-text',
  templateUrl: './styleable-text.component.html',
  styleUrls: ['./styleable-text.component.scss']
})
export class StyleableTextComponent {
  @Input()
  public text: string;
  @Input()
  public style: SafeStyle;

  constructor() {}
}
